import { TaskProps } from "./tasks_types"
import { ProjectProps } from "./project_types"
import { RFIProps } from "./rfi_types"
import { SubmittalProps } from "./submittal_types"
import { AssignmentProps } from "./assignment_types"
import { BidProps } from "./bid_types"
import { LucideIcon } from "lucide-react"

export type Roles = "Administrator" | "CEO" | "Estimator" | "Designer" | "Purchaser" | "Facilitator" | "IT" | "Accountant" | "Other"

export const RoleHierarchy = {
    'ADMIN': ['Administrator'],
    'IT': ['IT'],
    'MANAGERS': ['CEO', 'Estimator', 'Designer', 'Purchaser', 'Facilitator', 'IT', 'Accountant'],
    'FINANCE': ['Accountant'],
    'OTHER': ['Other']
}

// For the employee creation form
export const EMPLOYEE_ROLES = [
    "CEO",
    "Estimator",
    "Designer",
    "Purchaser",
    "Facilitator",
    "IT",
    "Accountant",
    "Administrator",
    "Other",
]

export type EmployeeProps = {
    id?: string,
    name: string,
    email: string,
    username: string,
    password: string,
    role: Roles,
    date_joined?: string,
    projects?: ProjectProps[]
    tasks?: TaskProps[] 
    RFIs?: RFIProps[]
    submittals?: SubmittalProps[]
    preferences?: EmployeePreferences
    assignments?: AssignmentProps[]
    bids?: BidProps[]
    nav_bar_items?: NavBarItemsProps
}

export type NavBarItemsProps = {
    user: {
        name: string
        email: string
        role: string
    }
    teams: {
        name: string
        logo: string | LucideIcon
        plan: string
    }[]
    navMain: {
        title: string
        url: string
        icon?: string | LucideIcon
        isActive?: boolean
        openInNewWindow?: boolean
        openInNewTab?: boolean
        additionalWindows?: {
            url: string
            title: string
        }[] // Used to open additional windows (Mainly used for the Project Reports page)
        items?: {
            title: string
            url: string
        }[]
    }[]
}

export type EmployeePreferences = {
    [key: string]: string | number | boolean | string[] | null
}

export type EmployeeNameEmail = {
    name: string
    email: string

    // Used for dropdowns (if for_selection is true)
    value: string
    label: string
}

export type EmployeeCreationProps = {
    id?: string
    name: string
    email: string
    username: string
    password1: string
    password2: string
    role: Roles
}
